import App from "./App";
import OldApp from "./OldApp";
import NewUiToggle from "./components/common/NewUiToggle";
import { NewUiProvider, useNewUi } from "./contexts/NewUiContext";

function UiModeContent() {
  const { isNewUiEnabled } = useNewUi();

  return (
    <>
      {isNewUiEnabled ? <App /> : <OldApp />}
      <NewUiToggle />
    </>
  );
}

function UiModeRoot() {
  return (
    <NewUiProvider>
      <UiModeContent />
    </NewUiProvider>
  );
}

export default UiModeRoot;
